import { getIsMobileWebBrowser } from '../utils/utils'

export const useGetIsMobileWebBrowser = () => {
  return getIsMobileWebBrowser()
}
